import React, { useState } from 'react'
import { Card, color, Text } from '@trivie/ui-mobile'
import { View, ViewStyle } from 'react-native'
import { RecallTooltip } from './recall-tooltip'

export const QuizStatsPanel = (props: any) => {
  const { item, total, index } = props

  const anchorRef = React.useRef<any>(null)
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <View
      ref={anchorRef}
      style={{
        flex: total % 2 !== 0 && index === total - 1 ? 0.492 : 1,
        marginRight: index % 2 == 0 ? 5 : 0,
        marginLeft: index % 2 !== 0 ? 5 : 0,
        marginBottom: 8,
      }}
    >
      <Card
        disabled={!item.showTooltip}
        onPress={() => setShowTooltip(true)}
        style={{ ...STAT_PANEL, height: 66 }}
      >
        {item.icon}
        <View style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Text text={item.title} variant="body1Emphasized" />
          <Text
            numberOfLines={1}
            tx={item.subtitle}
            variant="body2Emphasized"
            style={{ color: color.shade50 }}
          />
        </View>
        <RecallTooltip
          anchorRef={anchorRef}
          handleClose={(event: any) => {
            if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
              return
            }
            setShowTooltip(false)
          }}
          visible={showTooltip}
        />
      </Card>
    </View>
  )
}

const STAT_PANEL: ViewStyle = {
  borderRadius: 20,
  backgroundColor: '#fff',
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: 16,
  paddingLeft: 16,
  paddingBottom: 16,
  paddingVertical: 12,
  flex: 1,
  borderWidth: 2,
  borderColor: '#F3F2F1',
  justifyContent: 'flex-start',
  elevation: 3,
  zIndex: 9999,
}
